import { Injectable } from '@angular/core';

import { HttpClient } from './../http-client';
import { Config } from '../local/config';
import { UserData } from '../local/user-data';


/*
  Generated class for the TransactionProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TransactionProvider {


  constructor(public http: HttpClient,
    public userData: UserData,
    public config: Config) {
    console.log('Hello TransactionProvider Provider');
  }

  getAllTodayByAccount(id) {
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/transactions/today`;

    if(id) {
      link += `/${id}`;
    }

    return this.http.get(link, 1);
  }

  getAllByAccount(id) {
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/transactions/accounts/${id}`;

    return this.http.get(link, 1);
  }

  getTransactionTypeList() {

    return Promise.resolve({
      status: 'success',
      data: [
        /*{
          id: 1,
          title: 'Saldo Inicial'
        },*/
        {
          id: 2,
          title: 'Transferencia de saldo'
        },
        /*{
          id: 3,
          title: 'Préstamo'
        },*/
        {
          id: 4,
          title: 'Pago'
        },
        /*{
          id: 5,
          title: 'Corte de caja'
        },*/
        {
          id: 6,
          title: 'Gastos operativos'
        },
        /*{
          id: 7,
          title: 'Reestructuración'
        },*/
        {
          id: 8,
          title: 'Gastos administrativos'
        },
      ]
    });
  }

  makeTransaction(data: { 
    movementType: any, 
    accountId: any, 
    refAccountId: any, 
    concept: any,  
    amount: any, 
    location?: { latitude: any, longitude: any}}) {
      let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/transactions`;

      return this.http.post(link, data, 1);
    }



}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/providers/transaction/transaction.ts